import styled, { css } from 'styled-components';
import { AnimatePresence } from 'framer-motion';
import { Markdown } from 'vendor/mods/markdown/components/Markdown';
import { ChevronBottom } from 'src/components/icons/ChevronBottom';
import { media } from 'src/styles/designs';
import { transparentize } from 'polished';
import { ExpandTransition } from 'src/components/common/ExpandTransition';

export interface EventPageFAQItemProps {
  label: string;
  answer: string;
  isExpanded: boolean;
  toggleIsExpanded: () => void;
}

const Container = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.text.palette.primary};
`;

const Heading = styled.h2`
  font-weight: 600;
  font-size: 21px;
  line-height: 26px;
  margin-right: 20px;
  ${media.w.lessThan.desktop} {
    font-size: 18px;
  }
`;

const Header = styled.header<{ $active: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;
  cursor: pointer;
  border-bottom: 1px solid
    ${({ theme }) => transparentize(0.7, theme.palette.white)};
  svg {
    min-width: 13px;
    ${({ $active }) =>
      $active &&
      css`
        transform: rotate(180deg);
      `}
  }
  ${media.w.lessThan.desktop} {
    padding: 18px 0;
  }
`;

const Description = styled.div`
  border-bottom: 1px solid
    ${({ theme }) => transparentize(0.7, theme.palette.white)};
  font-size: 16px;
  line-height: 24px;
  font-weight: 300;
  padding: 20px 0 30px;
  b,
  strong {
    font-weight: 700;
  }
  ${media.w.lessThan.desktop} {
    font-size: 14px;
    line-height: 21px;
  }
`;

export const EventPageFAQItem = ({
  label,
  answer,
  isExpanded,
  toggleIsExpanded,
}: EventPageFAQItemProps) => (
  <Container>
    <Header $active={isExpanded} onClick={toggleIsExpanded}>
      <Heading>
        <Markdown>{label}</Markdown>
      </Heading>
      <ChevronBottom size={13} />
    </Header>
    <AnimatePresence initial={false}>
      {isExpanded && (
        <ExpandTransition key="content">
          <Description>
            <Markdown>{answer}</Markdown>
          </Description>
        </ExpandTransition>
      )}
    </AnimatePresence>
  </Container>
);
